module.exports = __webpack_public_path__ + "images/stop-icon.2dfddc102c0da61cb57de85babc57d11.png";